import { ControllerPaletteColor } from './__palette-color';

export enum ControllerThemeColor {
  BackgroundDefault = ControllerPaletteColor.GrayWhite,
  BackgroundLevel1 = ControllerPaletteColor.GrayWhite,
  BackgroundLevel2 = ControllerPaletteColor.Gray950,
  BackgroundPaper = ControllerPaletteColor.GrayWhite,
  DangerDark = ControllerPaletteColor.Red300,
  DangerLight = ControllerPaletteColor.Red900,
  DangerMain = ControllerPaletteColor.Red400,
  Divider = ControllerPaletteColor.Gray600,
  Gray50 = ControllerPaletteColor.Gray950,
  Gray100 = ControllerPaletteColor.Gray900,
  Gray200 = ControllerPaletteColor.Gray800,
  Gray400 = ControllerPaletteColor.Gray600,
  Gray600 = ControllerPaletteColor.Gray400,
  Gray700 = ControllerPaletteColor.Gray300,
  Gray800 = ControllerPaletteColor.Gray200,
  Gray900 = ControllerPaletteColor.Gray100,
  InfoDark = ControllerPaletteColor.Gray100,
  InfoLight = ControllerPaletteColor.Gray950,
  InfoMain = ControllerPaletteColor.Gray200,
  PrimaryDark = ControllerPaletteColor.Ngb400,
  PrimaryLight = ControllerPaletteColor.Ngb900,
  PrimaryMain = ControllerPaletteColor.Ngb500,
  SecondaryDark = ControllerPaletteColor.Gray100,
  SecondaryLight = ControllerPaletteColor.Gray900,
  SecondaryMain = ControllerPaletteColor.Gray200,
  SuccessAlt = ControllerPaletteColor.Minty500,
  SuccessDark = ControllerPaletteColor.Minty300,
  SuccessLight = ControllerPaletteColor.Minty900,
  SuccessMain = ControllerPaletteColor.Minty500,
  TextDisabled = ControllerPaletteColor.Gray600,
  TextPrimary = ControllerPaletteColor.Gray200,
  TextSecondary = ControllerPaletteColor.GrayWhite,
  WarningMain = ControllerPaletteColor.Canary500,
  WarningLight = ControllerPaletteColor.Canary900,
}
